import { useLanguage, LANGUAGES } from "@/lib/i18n";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const FLAG_URLS = {
  es: "https://flagcdn.com/w40/es.png",
  en: "https://flagcdn.com/w40/gb.png",
  fr: "https://flagcdn.com/w40/fr.png",
  de: "https://flagcdn.com/w40/de.png",
  it: "https://flagcdn.com/w40/it.png",
  pt: "https://flagcdn.com/w40/pt.png",
};

function Flag({ code, className = "" }) {
  return (
    <img
      src={FLAG_URLS[code]}
      alt={code}
      className={`inline-block w-5 h-3.5 object-cover rounded-sm ${className}`}
      loading="eager"
    />
  );
}

export function LanguageSelector({ variant = "light" }) {
  const { language, changeLanguage } = useLanguage();
  const current = LANGUAGES.find((l) => l.code === language);

  const borderClass = variant === "dark"
    ? "border-navy-700 bg-navy-800 text-white"
    : "border-slate-200 bg-white text-slate-700";

  return (
    <div className="flex items-center gap-1" data-testid="language-selector">
      <Select value={language} onValueChange={changeLanguage}>
        <SelectTrigger className={`h-8 w-[130px] text-xs font-body ${borderClass} px-2 gap-1.5`} data-testid="language-select-trigger">
          <span className="flex items-center gap-1.5">
            <Flag code={language} />
            <span>{current?.label}</span>
          </span>
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
              <span className="flex items-center gap-2 text-sm font-body">
                <Flag code={l.code} />
                {l.label}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
